import { filterToProductType } from '@ve/services/productTypeConverter';

export default (product, filter) => (filter === 'all' ? true : product.get('type') === filterToProductType(filter));